import type React from 'react';

import { Box } from 'ui/box';

const COLOR_TRANSITION_SX = {
  transitionProperty:
    'color, background-color, border-color, text-decoration-color, fill, stroke',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  transitionDuration: '100ms',
};

const OPACITY_TRANSITION_SX = {
  transitionProperty: 'opacity',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  transitionDuration: '100ms',
};

interface RadioIconProps {
  isSelected: boolean;
}

const RadioIcon = ({ isSelected }: RadioIconProps): React.JSX.Element => (
  <Box
    component="span"
    sx={[
      {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: '1rem',
        height: '1rem',
        borderRadius: '9999px',
        borderWidth: '2px',
        ...COLOR_TRANSITION_SX,
      },
      isSelected && {
        borderColor: 'tokens.navy.600',
        bgcolor: 'tokens.navy.600',
      },
      !isSelected && { borderColor: 'tokens.gray.300' },
    ]}
  >
    <Box
      component="span"
      sx={[
        {
          width: '0.375rem',
          height: '0.375rem',
          borderRadius: '9999px',
          bgcolor: 'common.white',
          ...OPACITY_TRANSITION_SX,
        },
        isSelected && { opacity: 1 },
        !isSelected && { opacity: 0 },
      ]}
    />
  </Box>
);

export default RadioIcon;
